// extracted by mini-css-extract-plugin
export default {"coverTheEachHere":"wallet_coverTheEachHere__KVLYl","absoluteDelete":"wallet_absoluteDelete__Lyges","coverTheMap":"wallet_coverTheMap__S3Dfg"};